import { PersonalisationDialog } from "./PersonalisationDialog";
export default PersonalisationDialog;
export * from "./PersonalisationDialog";
